module.exports = __webpack_public_path__ + "img/组 491@2x.8bc288cc.png";